import React from 'react';
import './App.scss';
import SustainabilityIndex from './components/sustainability-index/sustainability-index';



const App = () => {


  return (
    <div className="App">
      <div className="appContainer">
      
          <SustainabilityIndex/>
                    
      </div>
      
    </div>
  );
}

export default App;
